(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cr-chapter"]) return;
  try {
    
(function(){
  var prose=document.getElementById('cr-prose'),otp=document.getElementById('cr-otp');
  if(prose&&otp){prose.querySelectorAll('h2').forEach(function(h,i){if(!h.id)h.id='s'+(i+1);var a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent;otp.appendChild(a);});
    if(document.getElementById('faq')){var q=document.createElement('a');q.href='#faq';q.textContent='Frequently asked questions';otp.appendChild(q);}
    if(!otp.children.length)otp.parentNode.style.display='none';}
  var bar=document.getElementById('cr-progress');
  if(bar){var f=function(){var d=document.documentElement,h=d.scrollHeight-d.clientHeight;bar.style.width=(h>0?Math.min(100,d.scrollTop/h*100):0)+'%';};window.addEventListener('scroll',f,{passive:true});f();}
  /* Lessons read: kept only in this browser, so visitors can see where they left off */
  var K='crLessonsRead',me=document.querySelector('.cr-article')?.dataset.articleId,read={};try{read=JSON.parse(localStorage.getItem(K)||'{}')||{}}catch(e){}
  function paint(){var items=document.querySelectorAll('.cr-toc-left li[data-lesson]'),n=0;items.forEach(function(li){if(read[li.getAttribute('data-lesson')]){li.classList.add('is-read');n++}});var nav=document.querySelector('.cr-toc-left ol');if(nav&&n){var p=document.querySelector('.cr-toc-left__done');if(!p){p=document.createElement('p');p.className='cr-toc-left__done';nav.parentNode.appendChild(p)}p.textContent=n+' of '+items.length+' lessons read'}}
  paint();if(prose&&!read[me]){var mark=function(){var r=prose.getBoundingClientRect();if(r.bottom<window.innerHeight*1.15){read[me]=1;try{localStorage.setItem(K,JSON.stringify(read))}catch(e){}paint();window.removeEventListener('scroll',mark)}};window.addEventListener('scroll',mark,{passive:true})}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cr-post"]) return;
  try {
    
(function(){
  var prose=document.getElementById('cr-prose'),otp=document.getElementById('cr-otp');
  if(prose&&otp){prose.querySelectorAll('h2').forEach(function(h,i){if(!h.id)h.id='s'+(i+1);var a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent;otp.appendChild(a);});
    if(document.getElementById('faq')){var q=document.createElement('a');q.href='#faq';q.textContent='Frequently asked questions';otp.appendChild(q);}
    if(!otp.children.length)otp.parentNode.style.display='none';}
  var bar=document.getElementById('cr-progress');
  if(bar){var f=function(){var d=document.documentElement,h=d.scrollHeight-d.clientHeight;bar.style.width=(h>0?Math.min(100,d.scrollTop/h*100):0)+'%';};window.addEventListener('scroll',f,{passive:true});f();}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
